import * as S from "./styles";

const StepCard = ({title, description}) => {
  return (
    <S.Card>
      <div className="title-card">
        <h3>{title}</h3>
      </div>
      <div className="description-card">
        <p>{description}</p>
      </div>
    </S.Card>
  )
}

export default StepCard